import React from 'react';

import AdminPanel from './admin/AdminPanel';

export default function App() {
  return <AdminPanel />;
}
